import { Coordinates } from "../Types/Map";

const countrySet = "EG"
const limit = 20
export const zamazlkCoords = [31.222170096529567, 30.055463608825804];
export const URLS = {
    tomtomApi: "https://api.tomtom.com",
    googleHost: "https://maps.googleapis.com/maps/api",
    googlePlacesHost: "https://places.googleapis.com",
    getTomTomGeocodingUrl: (query: string) => `${URLS.tomtomApi}/search/2/geocode/${query}.json?storeResult=false&lon=${zamazlkCoords[0]}&lat=${zamazlkCoords[1]}&limit=${limit}&countrySet=${countrySet}&view=Unified&key=${import.meta.env.VITE_TOMTOM}`,
    getTomTomRoutingUrl: (stations: number[][], travelMode: string, avoidToll: boolean) => {
        const urlLocations = stations.reduce((acc, coordinates, i) => {
            const lon = coordinates[0]
            const lat = coordinates[1]
            if (i === 0) return `${lon},${lat}`
            return `${acc}:${lon},${lat}`
        }, "")
        return `${URLS.tomtomApi}/routing/1/calculateRoute/${urlLocations}/json?key=${import.meta.env.VITE_TOMTOM}&routeType=fastest&traffic=true${avoidToll ? "&avoid=tollRoads" : ""}&travelMode=${travelMode}`
    },
    getNominatimGeocodingUrl: (q: string) => `https://nominatim.openstreetmap.org/search?q=${q}&format=json&countrycodes=EG`,
    getOSRMRoutingUrl: (stations: number[][], profile: string) => {
        const urlLocations = stations.reduce((acc, coordinates, i) => {
            const lon = coordinates[0]
            const lat = coordinates[1]
            if (i === 0) return `${lon},${lat}`
            return `${acc};${lon},${lat}`
        }, "")
        return `http://router.project-osrm.org/route/v1/${profile}/${urlLocations}?alternatives=true&steps=true&annotations=true`
    },
    getGoogleGeocodingUrl: (address: string) => `${URLS.googleHost}/geocode/json?address=${encodeURIComponent(address)}&key=${import.meta.env.VITE_GOOGLE_MAPS}`,
    getGoogleGeocodingPlaceIdUrl: (placeId: string) => `${URLS.googleHost}/geocode/json?place_id=${placeId}&key=${import.meta.env.VITE_GOOGLE_MAPS}`,
    getGooglePlaceUrl: (address: string) => `${URLS.googleHost}/place/findplacefromtext/json?input=${encodeURIComponent(address)}&inputtype=textquery&key=${import.meta.env.VITE_GOOGLE_MAPS}`,
    postGoogleSearchUrl: () => `${URLS.googlePlacesHost}/v1/places:searchText`,
    postGoogleAutocompleteUrl: () => `${URLS.googlePlacesHost}/v1/places:autocomplete`,
    getGoogleDirectionsUrl: (origin: Coordinates, destination: Coordinates, wayPoints: Coordinates[]) => {
        let wayPointsInUrl = ''
        for (const point of wayPoints) {
            wayPointsInUrl += `${point.latitude},${point.longitude}`
        }
        if (wayPointsInUrl) {
            return `${URLS.googleHost}/directions/json?destination=${encodeURIComponent(`${destination.latitude},${destination.longitude}`)}&origin=${origin.latitude},${origin.longitude}&waypoints=${wayPointsInUrl.slice(0, -1)}&key=${import.meta.env.VITE_GOOGLE_MAPS}`
        }
        return `${URLS.googleHost}/directions/json?destination=${encodeURIComponent(`${destination.latitude},${destination.longitude}`)}&origin=${encodeURIComponent(`${origin.latitude},${origin.longitude}`)}&key=${import.meta.env.VITE_GOOGLE_MAPS}`
    },
    postGoogleRoutesUrl: (origin: Coordinates, destination: Coordinates, wayPoints: Coordinates[]) => {
        let wayPointsInUrl = 'https://routes.googleapis.com/directions/v2:computeRoutes'
        for (const point of wayPoints) {
            wayPointsInUrl += `${point.latitude},${point.longitude}`
        }
        if (wayPointsInUrl) {
            return `${URLS.googleHost}/directions/json?destination=${encodeURIComponent(`${destination.latitude},${destination.longitude}`)}&origin=${origin.latitude},${origin.longitude}&waypoints=${wayPointsInUrl.slice(0, -1)}&key=${import.meta.env.VITE_GOOGLE_MAPS}`
        }
        return `${URLS.googleHost}/directions/json?destination=${encodeURIComponent(`${destination.latitude},${destination.longitude}`)}&origin=${encodeURIComponent(`${origin.latitude},${origin.longitude}`)}&key=${import.meta.env.VITE_GOOGLE_MAPS}`
    },

}

export const travelModes = {
    car: "car",
    taxi: "taxi",
    bus: "bus",
    pedestrian: "pedestrian",
    motorcycle: "motorcycle",
}

export const profiles = {
    car: "car",
    bike: "bike",
    foot: "foot",
    driving: "driving",
}